import React from "react";
import { Box, Button, CircularProgress, Divider, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

export default function ActionBar({
  onClose,
  isFetching,
  disabled,
  statusHint,
}) {
  const theme = useTheme();
  const { t } = useTranslation("products");
  return (
    <>
      <Divider />
      <Box
        sx={{
          position: "sticky",
          bottom: 0,
          backgroundColor: theme.palette.background.paper,
          py: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: 1,
        }}
      >
        {statusHint ? (
          <Typography variant="caption" color="text.secondary" sx={{ width: "100%", textAlign: "right" }}>
            {statusHint}
          </Typography>
        ) : null}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, width: "100%" }}>
          <Button variant="outlined" onClick={onClose} disabled={isFetching}>
            {t("form.cancel")}
          </Button>
          <Button type="submit" variant="contained" disabled={disabled}>
            {isFetching ? <CircularProgress size={20} color="inherit" /> : t("form.save")}
          </Button>
        </Box>
      </Box>
    </>
  );
}
